import React, { FC, useRef } from 'react';
import type { PayallLifeMissionProps } from '@/types';
import { useInView } from '@/hooks/reveal-in-view';
import { ContentManager } from '../content-manager';
import SplitTextAnimation from '../split-text-animation';

export const PayallLifeMission: FC<PayallLifeMissionProps> = ({
  content
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
  return (
    <section ref={ref} className="payallLifeMission wrapper">
      <SplitTextAnimation
        htmlElement={
          <ContentManager
            content={content}
            className="payallLifeMission--content"
          />
        }
        isInView={isInView}
      />
    </section>
  );
};
